import PropTypes from 'prop-types';

export const Button = (props) => {
  const { label = "XXXXX", ejecutar, clases } = props;
  return (
    <button
      title={label}
      onClick={() => {
        ejecutar();
      }}
      className={`${clases}`}
    >
      {label}
    </button>
  );
};

Button.propTypes = {
  label: PropTypes.string,
  ejecutar: PropTypes.func,
  clases: PropTypes.string,
};

Button.defaultProps = {
  label: 'XXXXX',
  ejecutar: () => {},
  clases: '',
};
